import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, ArrowLeft, Loader2, CheckCircle2 } from "lucide-react";

const SUDEPORTE_LOGO = "/brand/sudefootball-white-40.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "No se pudo procesar la solicitud");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 lg:p-16 bg-background">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-start leading-none mb-10">
          <img src={SUDEPORTE_LOGO} alt="Sudefootball" className="h-10 w-auto" />
          <span className="font-heading font-black italic tracking-tight leading-none text-white text-xs mt-2">sudeporte</span>
        </div>

        {!sent ? (
          <>
            <div className="mb-10">
              <div className="overline mb-2">Recuperar acceso</div>
              <h2 className="font-heading font-black text-4xl tracking-tighter uppercase">¿Olvidaste tu contraseña?</h2>
              <p className="text-sm text-muted-foreground mt-3">
                Introduce el email con el que accedes a Sudefootball. Si existe una cuenta asociada, te enviaremos un enlace para restablecerla.
              </p>
            </div>

            <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-password-form">
              <div>
                <label className="overline block mb-2">Email</label>
                <input
                  type="email"
                  required
                  data-testid="forgot-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@club.com"
                  className="w-full h-11 bg-transparent border border-border px-3 focus:border-primary focus:outline-none transition-colors duration-200 font-mono text-sm"
                />
              </div>

              <button
                type="submit"
                data-testid="forgot-submit-btn"
                disabled={loading}
                className="btn-volt w-full justify-center"
              >
                {loading ? <Loader2 className="animate-spin" size={16} /> : <>Enviar enlace <ArrowRight size={16} /></>}
              </button>
            </form>
          </>
        ) : (
          <div data-testid="forgot-sent-banner" className="border border-primary/60 bg-primary/5 p-6">
            <CheckCircle2 className="text-primary mb-3" size={28} />
            <h2 className="font-heading font-black text-2xl uppercase tracking-tight mb-2">Comprueba tu bandeja</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Si <span className="font-mono text-foreground">{email}</span> está registrado en Sudefootball, recibirás un enlace de recuperación en unos minutos. El enlace caduca en 1 hora.
            </p>
            <p className="text-xs text-muted-foreground mt-3">¿No lo ves? Revisa la carpeta de spam.</p>
          </div>
        )}

        <div className="mt-10 pt-6 border-t border-border">
          <Link
            to="/login"
            data-testid="back-to-login-link"
            className="inline-flex items-center gap-2 text-xs font-heading uppercase tracking-wider text-muted-foreground hover:text-primary transition-colors duration-200"
          >
            <ArrowLeft size={14} /> Volver al login
          </Link>
        </div>
      </div>
    </div>
  );
}
